export default __webpack_public_path__ + "static/media/total-men-women-icon.155c411b.svg";